import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getClasificacionAreas = async () => {
  const response = await PrivateInterceptor('Global/ClasificacionAreas', 'GET');
  return response;
}

export const guardarClasificacion = async (Datos) => {
  const response = await PrivateInterceptor('Global/ClasificacionAreas/guardarClasificacion', 'POST', {Datos});
  return response;
}

export const chageEstadoClasificaciones = async (data) => {
  const result = await PrivateInterceptor(`Global/ClasificacionAreas/chageEstadoClasificaciones`, 'POST', data);
  return result;
}